/* unplugin-vue-components disabled */import { render } from "./PaperBlock.vue?vue&type=template&id=e11d7202&scoped=true"
import script from "./PaperBlock.vue?vue&type=script&lang=js"
export * from "./PaperBlock.vue?vue&type=script&lang=js"

import "./PaperBlock.vue?vue&type=style&index=0&id=e11d7202&scoped=true&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e11d7202"]])

export default __exports__